<template>
        <div class="main_container">
			<h3 style="margin-top:25px;">Edit DSP Campaign Tags</h3>
            <hr>
            
            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">Advertiser</label>
                <div class="col-sm-7 pr-5">
                    {{ currentAdvertiser.advertiser_name }}
                    
                </div>
			</div>

            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">Advertiser ID</label>
                <div class="col-sm-7 pr-5">
                    {{ currentAdvertiser.advertiser_id }}
                    
                </div>
			</div>
            
            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">Order</label>
                <div class="col-sm-7 pr-5">
                    {{ currentAdvertiser.name }}
                    
                </div>
			</div>
            
            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">Order ID</label>
                <div class="col-sm-7 pr-5">
                    {{ currentAdvertiser.order_id }}
                    
                </div>
			</div>
            
            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">Type</label>
                <div class="col-sm-7 pr-5">
                    DSP
                    
                </div>
			</div>

            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">Start Date</label>
                <div class="col-sm-7 pr-5">
                    {{ currentAdvertiser.start_date }}
                </div>
			</div>

            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">End Date</label>
                <div class="col-sm-7 pr-5">
                    {{ currentAdvertiser.end_date }}
                </div>
			</div>
            
            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">Brand<sup>*</sup></label>
                <div class="col-sm-7 pr-5 dsp-tags-add">
                    <div class="sel_fil_wrap three">
                        <multiselect
                        v-model="brand_tag"
                        :options="tagOptions.filter(t => t.type.toLowerCase() === 'brand')"
                        :show-no-results="true"
                        :searchable="true"
                        ref="multiselect"
                        label="title"
                        track-by="title"
                        open-direction="bottom"
                        :taggable="true"
                        placeholder="Select or enter new tag"
                        class="form-control multi-dropdown select_filter small-input"
                        selectLabel = ""
                        selectedLabel = ""
                        @tag="(newTagTitle) => {brand_tag = {title: newTagTitle, type: 'brand'}}"
                        />
                    </div>
                </div>
			</div>
            
            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">Category<sup>*</sup></label>
                <div class="col-sm-7 pr-5 dsp-tags-add">
			        <div class="sel_fil_wrap three">
                        <multiselect
                        v-model="category_tag"
                        :options="tagOptions.filter(t => t.type.toLowerCase() === 'product_category')"
                        :show-no-results="true"
                        :searchable="true"
                        ref="multiselect"
                        label="title"
                        track-by="title"
                        open-direction="bottom"
                        :taggable="true"
                        placeholder="Select or enter new tag"
                        class="form-control multi-dropdown select_filter small-input"
                        selectLabel = ""
                        selectedLabel = ""
                        @tag="(newTagTitle) => {category_tag = {title: newTagTitle, type: 'product_category'}}"
                        />
                    </div>
                </div>
			</div>

            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">Sub-Category<sup>*</sup></label>
                <div class="col-sm-7 pr-5 dsp-tags-add">
                    <div class="sel_fil_wrap three" >
                        <multiselect
                        v-model="subcategory_tag"
                        :options="tagOptions.filter(t => t.type.toLowerCase() === 'subcategory')"
                        :show-no-results="true"
                        :searchable="true"
                        ref="multiselect"
                        label="title"
                        track-by="title"
                        open-direction="bottom"
                        :taggable="true"
                        placeholder="Select or enter new tag"
                        class="form-control multi-dropdown select_filter small-input"
                        selectLabel = ""
                        selectedLabel = ""
                        @tag="(newTagTitle) => {subcategory_tag = {title: newTagTitle, type: 'subcategory'}}"
                        />
                    </div>   
                </div>
			</div>

            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">Style<sup>*</sup></label>
                <div class="col-sm-7 pr-5 dsp-tags-add">
                    <div class="sel_fil_wrap three" >
                        <multiselect
                        v-model="style_tag"
                        :options="tagOptions.filter(t => t.type.toLowerCase() === 'style')"
                        :show-no-results="true"
                        :searchable="true"
                        ref="multiselect"
                        label="title"
                        track-by="title"
                        open-direction="bottom"
                        :taggable="true"
                        placeholder="Select or enter new tag"
                        class="form-control multi-dropdown select_filter small-input"
                        selectLabel = ""
                        selectedLabel = ""
                        @tag="(newTagTitle) => {style_tag = {title: newTagTitle, type: 'style'}}"
                        />
                    </div>   
                </div>
			</div>
            
            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">Tactic 1<sup>*</sup></label>
                <div class="col-sm-7 pr-5 dsp-tags-add">
                    <div class="sel_fil_wrap three">
                        <multiselect
                        v-model="tactic1_tag"
                        :options="tactic1FilterOptions"
                        :show-no-results="true"
                        :searchable="true"
                        ref="multiselect"
                        label="value"
                        track-by="value"
                        open-direction="bottom"
                        :taggable="false"
                        placeholder="Select from dropdown"
                        class="form-control multi-dropdown select_filter small-input"
                        selectLabel = ""
                        selectedLabel = ""
                        />
                    </div>
                </div>
			</div>
            
            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">Tactic 2<sup>*</sup></label>
                <div class="col-sm-7 pr-5 dsp-tags-add">
                    <div class="sel_fil_wrap three" >
                        <multiselect
                        v-model="tactic2_tag"
                        :options="tactic2FilterOptions"
                        :show-no-results="true"
                        :searchable="true"
                        ref="multiselect"
                        label="value"
                        track-by="value"
                        open-direction="bottom"
                        :taggable="false"
                        placeholder="Select from dropdown"
                        class="form-control multi-dropdown select_filter small-input"
                        selectLabel = ""
                        selectedLabel = ""
                        />
                    </div>   
                </div>
			</div>

            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">GL<sup>*</sup></label>
                <div class="col-sm-7 pr-5 dsp-tags-add">
                    <div class="sel_fil_wrap three" >
                        <multiselect
                        v-model="gl_tag"
                        :options="tagOptions.filter(t => t.type.toLowerCase() === 'gl')"
                        :show-no-results="true"
                        :searchable="true"
                        ref="multiselect"
                        label="title"
                        track-by="title"
                        open-direction="bottom"
                        :taggable="true"
                        placeholder="Select or enter new tag"
                        class="form-control multi-dropdown select_filter small-input"
                        selectLabel = ""
                        selectedLabel = ""
                        @tag="(newTagTitle) => {gl_tag = {title: newTagTitle, type: 'gl'}}"
                        />
                    </div>   
                </div>
			</div>

            <button
                type="button"
                class="btn btn-primary"
                @click = "saveOrderTags()"
                data-dismiss="modal"
                >Save changes
            </button>
            <span class="returnSuccessMessage">{{ this.serverReturnMessage }}</span>
        </div>
</template>

    <script>
    import Multiselect from "vue-multiselect";


    export default {
        name: "DspAdvertiser",
        components:{
            Multiselect
        },
        async mounted() {
            this.serverReturnMessage = ''
            if(this.$store.state.currentDspAdvertiser) {
                this.orderId = this.$store.state.currentDspAdvertiser.order_id
                this.tagOptions = await this.$store.dispatch("getDspTagOptions", {advertiser_id: this.$store.state.currentDspAdvertiser.advertiser_id})
            } else {
                this.orderId = this.$route.params.orderId
                console.log('Loading advertiser from order:',this.orderId)
                const params = {
                    order_id: this.orderId,
                }
	            await this.$store.dispatch("getAdvertiserFromId",params) //.then( (resp) => {          
                    // console.log('RESPOSNE: TESTING: ', resp)
                    this.tagOptions = await this.$store.dispatch("getDspTagOptions", {advertiser_id: this.$store.state.currentDspAdvertiser.advertiser_id})
                // })

            }

            if (this.$store.state.currentDspAdvertiser.brand) {
                this.brand_tag = {title: this.$store.state.currentDspAdvertiser.brand, type: 'brand' }
            }

            if (this.$store.state.currentDspAdvertiser.product_category) {
                this.category_tag = {title: this.$store.state.currentDspAdvertiser.product_category, type: 'product_category' }
            }

            if (this.$store.state.currentDspAdvertiser.tactic_1) {
                this.tactic1_tag = {value: this.$store.state.currentDspAdvertiser.tactic_1, type: 'tactic_1' }
            }

            if (this.$store.state.currentDspAdvertiser.tactic_2) {
                this.tactic2_tag = {value: this.$store.state.currentDspAdvertiser.tactic_2, type: 'tactic_2' }
            }

            if (this.$store.state.currentDspAdvertiser.subcategory) {
                this.subcategory_tag = {title: this.$store.state.currentDspAdvertiser.subcategory, type: 'subcategory' }
            }

            if (this.$store.state.currentDspAdvertiser.style) {
                this.style_tag = {title: this.$store.state.currentDspAdvertiser.style, type: 'style' }
            }

            if (this.$store.state.currentDspAdvertiser.gl) {
                this.gl_tag = {title: this.$store.state.currentDspAdvertiser.gl, type: 'gl' }
            }


            console.log('Current Order ID',this.orderId,this.currentAdvertiser)            
        },
        data() {
            return {
                orderId: 0,
                brand:'',
                serverReturnMessageClass:'returnSuccessMessage',
                tactic1FilterOptions:[
                    { name: `Awareness`, value: `Awareness` },
                    { name: `Consideration`, value: `Consideration` },
                    { name: `Purchase`, value: `Purchase` },
                    { name: `Loyalty`, value: `Loyalty` }
                ],
                tactic2FilterOptions:[
                    { name: `Outside Aisle`, value: `Outside Aisle` },
                    { name: `Inside Aisle`, value: `Inside Aisle`},
                    { name: `Retargeting`, value: `Retargeting` },
                    { name: `Retention`, value: `Retention` },
                    { name: `Cross-sell`, value: `Cross-sell` },
                    { name: `Up-sell`, value: `Up-sell`},
                    { name: 'Added Value', value: 'Added Value'},
                    { name: 'Added Value - Targeting', value: 'Added Value - Targeting'},
                    { name: `Contextual`, value: `Contextual` },
                    { name: `Conquesting`, value: `Conquesting` },
                    { name: `FSA/HSA Eligible`, value: `FSA/HSA Eligible` },
                    { name: 'Excluded', value: 'Excluded'}
                ],
                brand_tag: '',
                category_tag: '',
                tactic1_tag: '',
                tactic2_tag: '',
                subcategory_tag: '',
                style_tag: '',
                gl_tag: '',
                tagOptions: []
            }
        },
        computed: {
            currentAdvertiser: {
                set(val) {
                this.$store.state.currentDspAdvertiser = val;
                },
                get() {
                return this.$store.state.currentDspAdvertiser;
                }
            },
            serverReturnMessage: {
                set(val) {
                this.$store.state.serverReturnMessage = val;
                },
                get() {
                return this.$store.state.serverReturnMessage;
                }
            }
        },
        methods: {
            saveOrderTags() {
                let params = {
                    order_ids: [this.currentAdvertiser.order_id],
                }
                if(this.brand_tag) {
                    params.brand_tag = this.brand_tag.title
                }
                if(this.category_tag) {
                    params.cat_tag = this.category_tag.title
                }
                if(this.tactic1_tag.value) {
                    params.t1_tag = this.tactic1_tag.value
                }
                if(this.tactic2_tag.value) {
                    params.t2_tag = this.tactic2_tag.value
                }
                if(this.style_tag) {
                    params.style_tag = this.style_tag.title
                }
                if(this.subcategory_tag) {
                    params.subcategory_tag = this.subcategory_tag.title
                }
                if(this.gl_tag) {
                    params.gl_tag = this.gl_tag.title
                }
                
                console.log('Saving...', params)
                this.serverReturnMessage = 'Saving...'
                this.serverReturnMessageClass = 'waitingMessage'
	            this.$store.dispatch("saveOrderTags",params)
            }
        }
    }
    </script>
<style lang="scss">
.dsp-tags-add {
    .multiselect__single {
        text-transform: none !important;
        overflow: hidden;
    }
    .multiselect__option span {
        text-transform: none !important;
    }
    .multiselect__tag {
        text-transform: none !important;
    }
}
.col-form-label {
    font-weight: bold;
}
.small-input {
    width:400px;
}
.waitingMessage {
    color: red;
}
.returnSuccessMessage {
    color: green;
}
.main_container {
    min-height: 1200px;
}
</style>